import { render, staticRenderFns } from "./memberPurchase.vue?vue&type=template&id=08983d0a&scoped=true&"
import script from "./memberPurchase.vue?vue&type=script&lang=js&"
export * from "./memberPurchase.vue?vue&type=script&lang=js&"
import style0 from "./memberPurchase.vue?vue&type=style&index=0&id=08983d0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08983d0a",
  null
  
)

export default component.exports